// extracted by mini-css-extract-plugin
export default {"page":"yL","top_block":"zL","heading":"AL","inner_text":"BL","starter_text":"CL","starter_cta":"EL","summary_block":"FL","cartsummary_wrap":"GL","price":"HL","pricing_wrap":"IL","summary_block_mob":"JL","summary":"KL","pricing_heading":"LL","products_summary":"ML","summary_line":"NL","summary_price":"OL","summary_title":"PL"};
    if(module.hot) {
      // 1713969935185
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  